import {
    CREATE_FABRIC_INFORMATION_REQUEST,
    CREATE_FABRIC_INFORMATION_SUCCESS,
    CREATE_FABRIC_INFORMATION_FAILURE,
    DELETE_FABRIC_INFORMATION_REQUEST,
    DELETE_FABRIC_INFORMATION_SUCCESS,
    DELETE_FABRIC_INFORMATION_FAILURE,
    FETCH_SINGLE_FABRIC_INFORMATION_REQUEST,
    FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS,
    FETCH_SINGLE_FABRIC_INFORMATION_FAILURE,
    FETCH_FABRIC_INFORMATION_REQUEST,
    FETCH_FABRIC_INFORMATION_SUCCESS,
    FETCH_FABRIC_INFORMATION_FAILURE,
    UPDATE_FABRIC_INFORMATION_REQUEST,
    UPDATE_FABRIC_INFORMATION_SUCCESS,
    UPDATE_FABRIC_INFORMATION_FAILURE,
    RESET_FABRIC_INFORMATION_INFO,
    CREATE_FABRIC_INFORMATION_FORM,
    UPDATE_FABRIC_INFORMATION_FORM,
    FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS,
    FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST,
    FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE,
    FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS,
    FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE,
    FETCH_FABRIC_INFO_INVOICE_REQUEST,
    FETCH_FABRIC_INFO_INVOICE_SUCCESS,
    FETCH_FABRIC_INFO_INVOICE_FAILURE,
    RESET_FABRIC_INFO_INVOICE,
    UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST,
    UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS,
    UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE,
    SEND_FAB_VERIFY_OTP_USERFORM_REQUEST,
    SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS,
    SEND_FAB_VERIFY_OTP_USERFORM_FAILURE,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS,
    FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE
} from './fabricInformation.actionsType';

export const FABRIC_INFORMATION = 'fabricInformation';

let initialState = {
    loading: false,
    fabricInformationList: [],
    fabricInformationListByStyleDetailId: [],
    fabricInformationForm: {
        fldIsprocessrequired: false,
        fldFKFabricType: []
    },
    fabricStyleListCount: [],
    yarnGroupList: [],
    yarnTypeList: [],
    fabricTypeList: [],
    fabricGroupList: [],
    departmentList: [],
    itemList: [],
    partList: [],
    locationList: [],
    selectedState: {},
    fabricMasterWithoutStyle: [],
    errorMessage: '',
    fabInfoInvoice: [],
    MultiList: [],
    verifyFabOTP: '',
    deleteFabricId: ''
};

export let fabricInformationReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_FABRIC_INFORMATION_REQUEST:
        case CREATE_FABRIC_INFORMATION_REQUEST:
        case UPDATE_FABRIC_INFORMATION_REQUEST:
        case FETCH_SINGLE_FABRIC_INFORMATION_REQUEST:
        case FETCH_FABRIC_BY_STYLE_DETAIL_ID_REQUEST:
        case FETCH_PROPERTY_FOR_FABRIC_INFO_REQUEST:
        case DELETE_FABRIC_INFORMATION_REQUEST:
        case FETCH_FABRIC_MASTER_WITHOUT_STYLE_REQUEST:
        case FETCH_FABRIC_INFO_INVOICE_REQUEST:
        case UPDATE_REGENERATE_FABRIC_INFORMATION_REQUEST:
        case SEND_FAB_VERIFY_OTP_USERFORM_REQUEST:
        case FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInformationList: updatePayload
            };
        case UPDATE_REGENERATE_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_FABRIC_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInformationListByStyleDetailId: updatePayload
            };
        case FETCH_FABRIC_MASTER_WITHOUT_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricMasterWithoutStyle: updatePayload
            };
        case CREATE_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInformationForm: {
                    fldIsprocessrequired: false
                }
            };
        case SEND_FAB_VERIFY_OTP_USERFORM_SUCCESS:
            return {
                ...state,
                loading: false,
                verifyFabOTP: updatePayload
            };
        case UPDATE_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInformationForm: {
                    fldIsprocessrequired: false
                }
            };
        case FETCH_SINGLE_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInformationForm: updatePayload
            };
        case DELETE_FABRIC_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                deleteFabricId: updatePayload,
                fabricInformationForm: {
                    fldIsprocessrequired: false
                }
            };
        case FETCH_FABRIC_INFO_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                fabInfoInvoice: updatePayload
            };
        case RESET_FABRIC_INFO_INVOICE:
            return {
                ...state,
                fabInfoInvoice: []
            };

        case RESET_FABRIC_INFORMATION_INFO:
            return {
                ...state,
                fabricInformationForm: {
                    fldIsprocessrequired: false
                },
                deleteFabricId: ''

            };
        case FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricStyleListCount: updatePayload,
            };
        case FETCH_PROPERTY_FOR_FABRIC_INFO_SUCCESS:
            if (payload == 14) {
                return {
                    ...state,
                    loading: false,
                    yarnGroupList: updatePayload
                };
            } else if (payload == 15) {
                return {
                    ...state,
                    loading: false,
                    yarnTypeList: updatePayload
                };
            } else if (payload == 17) {
                return {
                    ...state,
                    loading: false,
                    fabricTypeList: updatePayload
                };
            } else if (payload == 16) {
                return {
                    ...state,
                    loading: false,
                    fabricGroupList: updatePayload
                };
            } else if (payload == 54) {
                return {
                    ...state,
                    loading: false,
                    departmentList: updatePayload
                };
            } else if (payload == 55) {
                return {
                    ...state,
                    loading: false,
                    itemList: updatePayload
                };
            } else if (payload == 21) {
                return {
                    ...state,
                    loading: false,
                    partList: updatePayload,
                    locationList: updatePayload
                };

            } else if (payload == 88) {
                return {
                    ...state,
                    loading: false,
                    MultiList: updatePayload,
                };
            }
            else {
                return {
                    ...state,
                    loading: false
                };
            }
        case CREATE_FABRIC_INFORMATION_FORM:
        case UPDATE_FABRIC_INFORMATION_FORM:
            return {
                ...state,
                loading: false,
                fabricInformationForm: {
                    ...state.fabricInformationForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_FABRIC_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                fabricInformationListByStyleDetailId: [],
                ...state,
                loading: false
            };
        case FETCH_FABRIC_INFORMATION_FAILURE:
        case CREATE_FABRIC_INFORMATION_FAILURE:
        case UPDATE_FABRIC_INFORMATION_FAILURE:
        case FETCH_SINGLE_FABRIC_INFORMATION_FAILURE:
        case FETCH_PROPERTY_FOR_FABRIC_INFO_FAILURE:
        case FETCH_FABRIC_MASTER_WITHOUT_STYLE_FAILURE:
        case DELETE_FABRIC_INFORMATION_FAILURE:
        case FETCH_FABRIC_INFO_INVOICE_FAILURE:
        case UPDATE_REGENERATE_FABRIC_INFORMATION_FAILURE:
        case SEND_FAB_VERIFY_OTP_USERFORM_FAILURE:
        case FETCH_FABRIC_STYLE_DETAIL_LIST_COUNT_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
